"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormType = exports.FormParentType = exports.COLLECTION_FOCUS_GROUP_NAME = exports.AlaCarteContainerGroups = void 0;
let FormParentType = exports.FormParentType = /*#__PURE__*/function (FormParentType) {
  FormParentType["AlaCarte"] = "alacarte";
  FormParentType["ContentBased"] = "contentbased";
  return FormParentType;
}({});
let FormType = exports.FormType = /*#__PURE__*/function (FormType) {
  FormType["Group"] = "group";
  FormType["Category"] = "category";
  FormType["Collection"] = "collection";
  FormType["Global"] = "global";
  return FormType;
}({});
const SPECIAL_LIFE_EVENT_FIELD_GROUPS = ["EVENT_SELF_BIRTH_WHOLE", "EVENT_SELF_MARRIAGE_WHOLE", "EVENT_SELF_DEATH_WHOLE", "EVENT_SELF_RESIDENCE_WHOLE", "EVENT_SELF_ARRIVAL_WHOLE", "EVENT_SELF_DEPARTURE_WHOLE", "EVENT_SELF_MILITARY_WHOLE", "EVENT_SELF_ANY_WHOLE"];
const SPECIAL_FMC_FIELD_GROUPS = ["NAME_FATHER_WHOLE", "NAME_MOTHER_WHOLE", "NAME_SIBLING_WHOLE", "NAME_SPOUSE_WHOLE", "NAME_CHILD_WHOLE"];
const AlaCarteContainerGroups = exports.AlaCarteContainerGroups = {
  SPECIAL_LIFE_EVENT_CONTAINER: {
    fieldNameArr: SPECIAL_LIFE_EVENT_FIELD_GROUPS,
    isShowEventToolbar: true
  },
  SPECIAL_LEC_WHOLE: {
    fieldNameArr: SPECIAL_LIFE_EVENT_FIELD_GROUPS,
    isShowEventToolbar: false
  },
  SPECIAL_FMC_WHOLE: {
    fieldNameArr: SPECIAL_FMC_FIELD_GROUPS,
    isShowEventToolbar: false
  }
};
const COLLECTION_FOCUS_GROUP_NAME = exports.COLLECTION_FOCUS_GROUP_NAME = {
  Default: "default",
  Australian: "australian",
  Canada: "canada",
  English: "english",
  French: "french",
  German: "german",
  Irish: "irish",
  Italian: "italian",
  Mexico: "mexico",
  Netherlands: "netherlands",
  NewZealand: "new-zealand",
  Norway: "norway",
  Scottish: "scottish",
  Swedish: "swedish",
  UnitedKingdom: "united-kingdom",
  Usa: "usa",
  Welsh: "welsh",
  AfricanAmerican: "african-american",
  Jewish: "jewish",
  NativeAmerican: "native-american"
};